module.exports = __webpack_public_path__ + "img/th_A_Ballast.d180f6aa.jpg";